const failedOrderToTickMonitorPlugin = ({ ordersMonitor, txLogMonitors, }) => {
    const onOrdersBulkUpdate = createOnOrdersBulkUpdate({ txLogMonitors });
    const onStart = () => {
        ordersMonitor.on('orders-bulk-update', onOrdersBulkUpdate);
    };
    const onStop = () => {
        ordersMonitor.off('orders-bulk-update', onOrdersBulkUpdate);
    };
    return { onStart, onStop };
};
function createOnOrdersBulkUpdate({ txLogMonitors }) {
    return (orders) => {
        for (const { order, changes } of orders) {
            if (changes.status === 'refunded') {
                if (!order.fromAsset || !order.fromWalletAccount)
                    continue;
                txLogMonitors.update({
                    assetName: order.fromAsset,
                    walletAccount: order.fromWalletAccount,
                    highPriority: true,
                });
            }
        }
    };
}
const failedOrderToTickMonitorPluginDefinition = {
    id: 'failedOrderToTickMonitorPlugin',
    type: 'plugin',
    factory: failedOrderToTickMonitorPlugin,
    dependencies: ['ordersMonitor', 'txLogMonitors'],
    public: true,
};
export default failedOrderToTickMonitorPluginDefinition;
